const getCurrentFormattedDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if month < 10
    const day = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if day < 10
    return `${year}-${month}-${day}`; // Return date in yyyy-mm-dd format
  };

  const currentDateFormatted = getCurrentFormattedDate(); // Format the current date as dd/mm/yyyy

  const validateNumber = (value: number) => {
    const isValidNumber = /^[0-9]+(?!.*[.,e-])/.test(value.toString());
    return isValidNumber ? true : 'Debes ingresar sólo números';
  };

  //patterns and validations for fields
  export const PATTERNS_VALIDATIONS = {
    email: {
      pattern : {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: "El correo no es válido"
      }
    },
    phone: {
      pattern : {
      value: /^[0-9]+$/,
      message: "El número de teléfono no es válido",
      },
      max: {
        value: 9999999999, 
        message: "El límite de caracteres es de 10"
      },
    },
    cellPhoneNumber: {
      pattern : {
      value: /^[0-9]+$/,
      message: "El número de celular no es válido",
      },
      max: {
        value: 9999999999, 
        message: "El límite de caracteres es de 10"
      },
    },
    expeditionDate: {
      max : {
        value: currentDateFormatted, 
        message: "La fecha no puede ser mayor a la fecha actual"
      },
    },
    dateOfBirth : {
      max : {
        value: currentDateFormatted, 
        message: "La fecha no puede ser mayor a la fecha actual"
      },
    },
    dateSubsideUnemployment : {
        max : {
          value: currentDateFormatted, 
          message: "La fecha no puede ser mayor a la fecha actual"
        },
    },
    laborTermination : {    
        max : {
            value: currentDateFormatted,
            message: "La fecha no puede ser mayor a la fecha actual"
        },
    },
    accountNumber : {
      pattern : {
        value: /^[0-9]+$/,
        message: "Debes ingresar sólo números",
        },
        validate : (value) => { return validateNumber(value)},
        required : {
          value: true,
          message: "Campo requerido, escriba sólo números.",
        },
        min: {
          value: 0,
          message: "Debes ingresar sólo números positivos.",
        },
    }, 
    address : {
      required : { value: true, message: "Por favor completa los campos requeridos en la dirección" }
    }
 };